<nav mat-tab-nav-bar class="menu">
  <!--*ngIf="canAccess('Audit')"-->
  <a *ngIf="showAudit"
    class="menu__item"
    mat-tab-link
    routerLink="/audit"
    routerLinkActive
    #auditLinkActive="routerLinkActive"
    [active]="auditLinkActive.isActive">Audits</a>
  <a *ngIf="showSid"
    class="menu__item"
    mat-tab-link
    routerLink="/sid"
    routerLinkActive
    #sidLinkActive="routerLinkActive"
    [active]="sidLinkActive.isActive">Self Identified Deviation</a>
  <a *ngIf="showSysAdmin"
    class="menu__item"
    mat-tab-link
    routerLink="/admin/auditType"
    routerLinkActive
    #adminLinkActive="routerLinkActive"
    [active]="adminLinkActive.isActive">Administration</a>
</nav>
